import $ from 'jquery';
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import vSelect from 'vue-select';
import "vue-select/dist/vue-select.css";
import { initClient } from "../../../api";
import { SettingsApiControllerUIClient } from "../../backend/backendapi";

type Templates = {
    de: string[],
    en: string[],
    hu: string[],
    sl: string[],
    hr: string[],
};

@Component({
    name: 'DescriptionEditModal',
    components: {
        vSelect
    }
})
export default class DescriptionEditModal extends Vue {
    @Prop({ required: true })
    modalId!: string;
    @Prop({ required: true })
    description!: string;

    private readonly settingsApi = initClient(SettingsApiControllerUIClient);

    private templates: Templates | null = null;

    //init
    mounted(): void {
        this.reloadAll();
    }

    private async reloadAll(): Promise<void> {
        await this.reloadTemplateDescriptions();
    }

    private async reloadTemplateDescriptions(): Promise<void> {
        this.templates = (await this.settingsApi.getSystemSetting('activity.description.template')).result;
    }

    //public functions
    openModal(): void {
        $('#' + this.modalId).modal('show');
    }

    closeModal(): void {
        $('#' + this.modalId).modal('hide');
    }

    //private functions
    private close(): void {

    }

    private save(): void {
        this.$emit('saved', this.description);
    }

    //event handlers
    private onVScelected(value: string): void {
        this.description = value;
    }

    //getter
    private get templatesForVSelect(): string[] {
        if (!this.templates) {
            return [];
        }
        let lang = this.$i18n.locale;
        switch (lang) {
            case 'de':
                return this.templates.de;
            case 'hu':
                return this.templates.hu;
            case 'hr':
                return this.templates.hr;
            case 'sl':
                return this.templates.sl;
            default:
                return this.templates.en;
        }
    }
}